<template>
  <div class="container">
    <blacklist-datatable />
  </div>
</template>

<script>
import BlacklistDatatable from "./blacklist_datatable/Index.vue";

export default {
  name: "BlacklistIndex",
  components: { BlacklistDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
